const IS_DEV = process.env.NODE_ENV === 'development';

// Flip to true if coingecko is having issues (https://status.coingecko.com/)
const IS_COINGECKO_INCIDENT_ONGOING = false;

module.exports = {
  IS_DEV,
  IS_COINGECKO_INCIDENT_ONGOING,
};
